import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import { Link, useNavigate } from 'react-router-dom';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import globalIP from '../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import {
  Button,
  Form,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  Modal,
  IconButton,
  Table,
  CellProps,
  Dropdown,
  Input,
  SelectPicker,
  FlexboxGrid,
  Col,
  Checkbox,
  Message,
  useToaster,
  Tooltip,
  Whisper,
  Pagination
} from 'rsuite';
import { Icon } from '@rsuite/icons';
import TrashIcon from '@rsuite/icons/Trash';
import ProjectIcon from '@rsuite/icons/Project';
import { useLocation } from 'react-router-dom';
import TreemapIcon from '@rsuite/icons/Treemap';
import ugr from '@/UGRoute';
import TableCustomizeDetails from '@/components/TableEditDetails/TableCustomizeDetails';
import Footer from '@/components/Footer/Footer';

type YourDataType = {
  id: number;
  attributes: {
    CoverImage: any;
    ProductName: string;
    ProductId: string;
    ProductType: string;
    SizeUnit: string;
    Length: number;
    Width: number;
    Color: string;
    Finish: string;
    SellingPrice: number;
    MOQ: number;
    CategoryName: string;
    ProductTypeName: string;
    Description: string;
    Height: number;
    FinishName: string;
    NetWeight: string;
    ColorName: string;
    GrossWeight: number;
    SellingPriceCurrency: number;
    Product_Remark: string;
    cbm: number;
    SizeRange: string;
    // Add other attribute properties here
  };
};

const { Cell } = Table;

export const ImageCell = ({ rowData, dataKey, ...props }: CellProps) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div
      style={{
        width: 40,
        height: 40,
        background: '#f5f5f5',
        borderRadius: 6,
        marginTop: 2,
        overflow: 'hidden',
        display: 'inline-block'
      }}
    >
      <img src={rowData[dataKey!]} width="40" />
    </div>
  </Cell>
);

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

interface MetaData {
  pagination: PaginationData;
}
let catalogueCodeCounter = 1;

const EditDetailsC = () => {
  const dataFromSession = sessionStorage.getItem('fullName');
  const Name = JSON.parse(dataFromSession);

  const [show, setShow] = React.useState(true);


  const ipp = globalIP;

  const { HeaderCell, Cell } = Table;

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const defaultColumns = [
    {
      key: 'serialNumber',
      label: <b>Sr.No.</b>,
      fixed: true,
      width: 60
    },
    {
      key: 'Image',
      label: 'Image',
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }}>
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
              </Tooltip>
            );

            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${ipp}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`
                )}
              >
                <img
                  src={`${ipp}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-16px' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'CategoryName',
      label: `${label[0]?.attributes.Category}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Category}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.CategoryName" />
    },
    {
      key: 'ProducttypeName',
      label: `${label[0]?.attributes.ProductType}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductType}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductTypeName" />
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductId" />
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 200,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.Description" />
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductName" />
    },
    {
      key: sizeshow ? 'SizeRange' : 'Dimension',
      label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'Dimension',
      width: 200,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{sizeshow ? label[0]?.attributes.SizeRange : 'Dimension'}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            sizeshow
              ? rowData.attributes.SizeRange
              : `${rowData.attributes.Length} x ${rowData.attributes.Width} x ${rowData.attributes.Height} ${rowData.attributes.SizeUnit}`
          }
        </Cell>
      )
    },
    // {
    //   key: 'Size',
    //   label: `${label[0]?.attributes.SizeRange}`,
    //   width: 150,
    //   align: 'center',
    //   headerCell: <Table.HeaderCell flexGrow={1}><b>{label[0]?.attributes.SizeRange}</b></Table.HeaderCell>,
    //   cell: <Table.Cell dataKey="attributes.SizeRange" />
    // },

    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.FinishName" />
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ColorName" />
    },
    {
      key: 'NetWt',
      label: `${label[0]?.attributes.NetWgt}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.NetWgt}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.NetWeight" />
    },
    {
      key: 'GrossWt',
      label: `${label[0]?.attributes.GrossWgt}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.GrossWgt}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.GrossWeight" />
    },
    {
      key: 'Currency',
      label: `${label[0]?.attributes.Currency}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Currency}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.SellingPriceCurrency" />
    },
    {
      key: 'ProductCost',
      label: `${label[0]?.attributes.SalePriceINR}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.SalePriceINR}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductCost" />
    },
    {
      key: 'ProductR',
      label: `${label[0]?.attributes.ProductRemark}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductRemark}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.Product_Remark" />
    },
    {
      key: 'cbm',
      label: `${label[0]?.attributes.cbm}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.cbm}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.Total_CBM" />
    },
    {
      key: 'Action',
      label: 'Action',
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell style={{ padding: '6px' }}>
          {rowData => paginatedData.length > 1 && (
            <IconButton
              size="sm"
              icon={<TrashIcon />}
              active
              onClick={() => handleDeleteRow(rowData.id)}
            />
          )}
        </Table.Cell>
      )
    }
  ];

  const toaster = useToaster();

  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => {
    setOpen1(false);
  };
  const [open4, setOpen4] = React.useState(false);
  const handleOpen4 = () => setOpen4(true);
  const handleClose4 = () => setOpen4(false);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    setOpen2(false);
  };
  const ip = ipp;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const selectedItemsArray = selectedItems.split(',');
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = React.useState(false);
  const [columnKeys, setColumnKeys] = React.useState(
    defaultColumns
      .map(column => column.key)
      .filter(key => key !== 'ProductCost' && key !== 'Currency')
  );
  const CustomCell = CompactCell;
  const CustomHeaderCell = CompactHeaderCell;
  const [selectedAttributes, setSelectedAttributes] = useState();
  useEffect(() => {
    if (columnKeys.length) {
      const updatedAttributes = {
        Cust_Aliascode: columnKeys.includes('ProductId'),
        Cust_Productname: columnKeys.includes('ProductName'),
        Cust_Description: columnKeys.includes('Description'),
        Cust_Producttype: columnKeys.includes('ProducttypeName'),
        Cust_Category: columnKeys.includes('CategoryName'),
        Cust_Finish: columnKeys.includes('FinishName'),
        Cust_Color: columnKeys.includes('ColorName'),
        Cust_NetWgt: columnKeys.includes('NetWt'),
        Cust_GrsWgt: columnKeys.includes('GrossWt'),
        Cust_SalePrice: columnKeys.includes('ProductCost'),
        Cust_CBM: columnKeys.includes('cbm'),
        Cust_Unit: columnKeys.includes('SizeUnit'),
        Cust_FreeSize: columnKeys.includes('SizeRange')
      };
      setSelectedAttributes(updatedAttributes);
    }
  }, [columnKeys]);
  useEffect(() => {
    setColumnKeys(previousKeys => {
      if (sizeshow) {
        return [...previousKeys, 'SizeRange'];
      } else {
        return previousKeys.filter(key => key !== 'SizeRange');
      }
    });
  }, [sizeshow]);

  // Fetch Data from API Start
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [meta123, setMeta123] = useState<MetaData>();
  const [data123, setData123] = useState<YourDataType[]>([]);
  const [data1234, setData1234] = useState<YourDataType[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const selectedItems = searchParams.get('selectedItems') || '';
    const selectedItemsArray = selectedItems.split(',').filter(id => id);
    if (selectedItemsArray.length === 0) {
      setData1234([]); // No selected items, set data1234 to an empty array
      return;
    }
    const productvarid = selectedItemsArray.map(id => `filters[id][$eq]=${id}`).join('&');
    setProgress(30);
    setLoading(true);
    const response = await fetch(
      `${ipp}/api/products?${productvarid}&populate=*&pagination[page]=1`
    );
    setProgress(60);
    const json = await response.json();
    const allSelectedItems = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ipp}/api/products?${productvarid}&populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allSelectedItems.push(...pageJson.data);
    }
    const responsevar = await fetch(`${ipp}/api/variant-products?${productvarid}&populate=*`);
    const jsonvar = await responsevar.json();
    const newData1234 = [...allSelectedItems, ...jsonvar.data];
    setData1234(newData1234);
    setLoading(false);
    setProgress(100);
    setIsDataFetched(true);
  };
  const [page, setPage] = useState(1);
  useEffect(() => {
    fetchData123();
  }, [page]);
  const fetchData123 = async () => {
    try {
      let searchQryFilter = '';

      if (searchQuery.length > 0) {
        const searchQryy = searchQuery.trim();
        const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}`;
        searchQryFilter = `&${searchQry}`;
      }

      const response = await fetch(
        `${ipp}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${page}${searchQryFilter}`
      );

      if (!response.ok) {
        console.error("Failed to fetch products");
        return;
      }

      const json = await response.json();

      // Filter out authorized products
      const filteredData = json.data.filter(
        product => product.attributes.Authorized == "Authorised"
      );
      setData123(filteredData);
      setMeta123(json.meta);

    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };


  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    // setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setPage(1);
    fetchData123(); // Your data fetching function
  }, [debouncedSearchQuery]);

  const handleChangeLimit = () => {
    setPage(1);
  };

  //  Fetch Data from API End
  const [currentPage, setCurrentPage] = useState(1);
  const dataWithSerialNumbers = data1234
    .slice()
    .reverse()
    .map((item, index) => ({
      ...item,
      serialNumber: index + 1
    }));
  const paginatedData = dataWithSerialNumbers.slice((currentPage - 1) * 10, currentPage * 10);
  const handleDeleteRow = id => {
    // Remove the row from the data
    setData1234(prevData => prevData.filter(item => item.id !== id));

    // Remove the ID from URL params
    const searchParams = new URLSearchParams(window.location.search);
    const selectedItems = searchParams.get('selectedItems');

    if (selectedItems) {
      const selectedItemsArray = selectedItems.split(',').map(Number); // Convert to numbers
      const updatedSelectedItems = selectedItemsArray.filter(itemId => itemId !== id);
      const updatedSelectedItemsString = updatedSelectedItems.join(',');

      // Update URL params
      if (updatedSelectedItems.length > 0) {
        searchParams.set('selectedItems', updatedSelectedItemsString);
      } else {
        searchParams.delete('selectedItems'); // Remove the param if no IDs left
      }

      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.pushState({}, '', newUrl);
    }
  };

  const handleToggleChange = checked => {
    if (checked) {
      // Show the 'ProductCost' column
      setColumnKeys(prevColumnKeys => [...prevColumnKeys, 'ProductCost']);
    } else {
      // Hide the 'ProductCost' column
      setColumnKeys(prevColumnKeys => prevColumnKeys.filter(key => key !== 'ProductCost'));
    }
  };

  const GotoProductDesignwithId = useNavigate();
  const uddateProduct = data => {
    if (cata.catalogueName === '') {
    } else {
      const encodedData = encodeURIComponent(JSON.stringify(data));
      GotoProductDesignwithId(
        `/${ugr}/generate-catalogue1?id=${cata.id}&cataloguename=${cata.catalogueName}`
      );
      // GotoProductDesignwithId(
      //   `/${ugr}/generate-catalogue1?data=${encodedData}&cataloguename=${cata.catalogueName}&cataloguecode=${cata.CatalogueCode}&buyername=${cata.BuyerName}`
      // );
    }
  };

  const [qut, setQut] = useState({
    QuotationName: '',
    Q_BuyerCompany: '',
    Q_BuyerEmail: '',
    QuotationCode: '',
    Q_BuyerName: '',
    Q_Status: 'Active',
    QuotationProduct: [
      {
        QuotationProductcode: '',
        QuotationCode: ''
      }
    ]
  });
  interface Product {
    QuotationProductcode: string;
    QuotationCode: string;
    Price?: number; // Optional Price property
    MOQ?: number; // Optional MOQ property
  }

  const [cata, setCata] = useState({
    catalogueName: '',
    BuyerCompany: '',
    BuyerEmail: '',
    CatalogueCode: '',
    BuyerName: '',
    Status: 'Active',
    CreateBy: Name,
    CatalogueProduct: [
      {
        CatalogProduct: '',
        CatalogCode: ''
      }
    ]
  });

  const [qutadata, setQutadata] = React.useState([]);
  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    const response = await fetch(`${ipp}/api/quotations`);
    const json = await response.json();
    setQutadata(json.data);
  };

  const [cataloguedata, setCataloguedata] = React.useState([]);
  useEffect(() => {
    fetchData0();
  }, []);
  const fetchData0 = async () => {
    const response = await fetch(`${ipp}/api/catalogues`);
    const json = await response.json();
    setCataloguedata(json.data);
  };

  const generateCatalogue = () => {
    const categoryCount = cataloguedata.length;
    const nextCode = categoryCount + 1;
    return `CATLG-${nextCode.toString().padStart(3, '0')}`;
  };

  const generateCollection = () => {
    const categoryCount = qutadata.length;
    const nextCode = categoryCount + 1;
    return `QUOT-${nextCode.toString().padStart(3, '0')}`;
  };

  const url2 = `${ipp}/api/catalogues`;
  const submit = async (e) => {
    e.preventDefault();

    if (!cata.catalogueName) {
      toaster.push(
        <Message showIcon type="error">Please Enter Catalogue Name</Message>,
        { placement: "topEnd" }
      );
      return null;
    }

    try {
      const nextCatalogueCode = generateCatalogue();
      const formData = new FormData();

      const updatedCatalogue = {
        ...cata,
        CatalogueCode: nextCatalogueCode,
        ...selectedAttributes,
        CatalogueProduct: data1234.map(item => ({
          CatalogProduct: String(item.id),
          CatalogCode: nextCatalogueCode,
          catcd: String(item.attributes.CategoryName),
          prodtypecd: String(item.attributes.ProductTypeName),
          aliascd: String(item.attributes.ProductId),
          productname: String(item.attributes.ProductName),
          description: String(item.attributes.Description),
          unit: String(item.attributes.SizeUnit),
          len: item.attributes.Length,
          wid: item.attributes.Width,
          thick: item.attributes.Height,
          finish: String(item.attributes.FinishName),
          color: String(item.attributes.ColorName),
          netwgt: item.attributes.NetWeight,
          grswgt: item.attributes.GrossWeight,
          saleprice: item.attributes.SellingPrice,
          currency: String(item.attributes.SellingPriceCurrency),
          remark: String(item.attributes.Product_Remark),
          shape: "N/A",
          cbm: item.attributes.cbm,
        }))
      };

      formData.append("data", JSON.stringify(updatedCatalogue));

      const response = await fetch(url2, {
        method: "POST",
        body: formData
      });

      const result = await response.json();

      // ------------------------------
      // ⭐ Correct Strapi response
      // ------------------------------
      const created = result?.data;
      if (!created) return null;

      const newId = created.id;
      const newName = created.attributes?.catalogueName ?? cata.catalogueName;

      // ⭐ Redirect correctly
      GotoProductDesignwithId(
        `/${ugr}/generate-catalogue1?id=${newId}&cataloguename=${newName}`
      );

      // Store ID in state if needed
      setCataId(newId);

      return newId;

    } catch (err) {
      console.error("Catalogue create error:", err);
      return null;
    }
  };

  const url3 = `${ipp}/api/quotations`;
  const submit2 = e => {
    e.preventDefault();
    if (qut.QuotationName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Quotation Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      const nextCatalogueCode = generateCollection();
      const formData = new FormData();

      const selectedProducts: Product[] = data1234.map(item => {
        const product = {
          QuotationProductcode: String(item.id),
          QuotationCode: nextCatalogueCode,
          Price: item.attributes.SellingPrice,
          MOQ: item.attributes.MOQ
        };

        return product;
      });
      const updatedCatalogue = {
        ...qut,
        QuotationCode: nextCatalogueCode,
        QuotationProduct: selectedProducts
      };
      formData.append('data', JSON.stringify(updatedCatalogue));
      fetch(url3, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // console.log(data);
          handleClose2();
          handleOpen4();
        })
        .catch(error => console.error(error));
      catalogueCodeCounter++;
    }
  };

  // const [spt1Name, setSTP1Name] = useState('')
  const handleInputChange = (inputName, event, index) => {
    let value;
    if (event && event.target) {
      // If event is not null and has a target property
      value = event.target.value;
    } else {
      // Handle cases where event is null or doesn't have a target property
      value = event;
    }
    if (inputName == 'BuyerCompany') {
      setSelectedCompany(value);
    }
    if (inputName == 'BuyerName') {
      setSelectedBuyer(value);
    }

    setCata({ ...cata, [inputName]: value });
  };
  const handleInputChangeQ = (inputName, event, index) => {
    let value;
    if (event && event.target) {
      // If event is not null and has a target property
      value = event.target.value;
    } else {
      // Handle cases where event is null or doesn't have a target property
      value = event;
    }
    if (inputName == 'Q_BuyerCompany') {
      setSelectedCompany(value);
    }
    if (inputName == 'Q_BuyerName') {
      setSelectedBuyer(value);
    }

    setQut({ ...qut, [inputName]: value });
  };

  const Navigate = useNavigate();
  const datattt = () => {
    if (cata.catalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      submit(event);
      uddateProduct(data1234);
    }
  };
  const datattt2 = () => {
    if (qut.QuotationName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Quotation Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      submit2(event);
    }
  };

  const [companydataa, setCompanydataa] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  useEffect(() => {
    fetchData6();
  }, []);

  const fetchData6 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-companies`);
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.companynm,
        value: item.attributes.companynm
      }));
      setCompanydataa(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [buyeerdata, setBuyeerdata] = React.useState([]);
  const buyeerdata1 = [];
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(
        `${ip}/api/buyer-details?populate=*&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyernm,
        company: item.attributes.companynm
      }));
      setBuyeerdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const filteredBuyerData = selectedCompany
    ? buyeerdata.filter(item => item.company === selectedCompany)
    : buyeerdata1;

  const [temp, setTemp] = React.useState([]);
  useEffect(() => {
    fetchDatatemp();
  }, []);

  const fetchDatatemp = async () => {
    try {
      const response = await fetch(`${ip}/api/temp-libs`);
      const json = await response.json();
      setTemp(json.data);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [selectedBuyer, setSelectedBuyer] = useState(null); // Step 1

  // Step 2: Check if there's a matching Temp_Buyer in the temp data
  const findMatchingTempBuyer = () => {
    const tempBuyer = temp.find(item => item.attributes.Temp_Buyer === selectedBuyer);
    return tempBuyer ? tempBuyer.attributes.Temp_Name : null;
  };
  const defaultTempBuyer = temp.find(item => item.attributes.Temp_Buyer === 'Default');
  const defaultTempName = defaultTempBuyer ? defaultTempBuyer.attributes.Temp_Name : null;

  // Step 3: Render the SPT1 div conditionally
  const spt1Name = findMatchingTempBuyer();

  const [showModal, setShowModal] = useState(false);
  const [modalSelectedItems, setModalSelectedItems] = useState([]);

  const handleOpenModal = () => {
    setShowModal(true);
    setModalSelectedItems([...data1234.map(item => item.id)]); // Initialize with currently selected products
  };

  const handleConfirmModal = () => {
    const newSelectedItems = modalSelectedItems.map(Number); // Convert to numbers
    const newSelectedItemsString = newSelectedItems.join(',');
    // Update URL params
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('selectedItems', newSelectedItemsString);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', newUrl);
    // Fetch data based on the new selection
    fetchData();
    setShowModal(false);
  };

  const handleModalCheckboxChange = (value, checked) => {
    if (checked) {
      setModalSelectedItems(prevSelected => [...prevSelected, value]);
    } else {
      setModalSelectedItems(prevSelected => prevSelected.filter(item => item !== value));
    }
  };
  const handleSearch = value => {
    setSearchQuery(value);
  };

  const [selectedFormat, setSelectedFormat] = useState('A');
  const handleFormatChange = value => {
    setSelectedFormat(value);
  };
  const [selectedFormat1, setSelectedFormat1] = useState('A');
  const handleFormatChange1 = value => {
    setSelectedFormat1(value);
  };
  const [selectedShare, setSelectedShare] = useState('A');
  const handleFormatChangeShare = value => {
    setSelectedShare(value);
  };

  const handlePanelClick = value => {
    setSelectedFormat1(value);
  };

  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchDataco();
  }, []);
  const fetchDataco = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 220; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">Catalogues</h3>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/selection`}>Select Product</Link>
                </Breadcrumb.Item>

                <Breadcrumb.Item active>Edit Details</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>

          <Stack spacing={10}>
            {/* <label>Pricing: </label> */}
            {/* <Toggle checked={columnKeys.includes('ProductCost')} onChange={handleToggleChange} /> */}
            <Button appearance="subtle" active onClick={handleOpenModal}>
              Add More Product
            </Button>
            <Button appearance="ghost" color="cyan" onClick={handleOpen}>
              Customize Table
            </Button>
            <Dropdown
              title="Create"
              placement="bottomEnd"
              color="cyan"
              appearance="primary"
              disabled={!isDataFetched}
            >
              <Dropdown.Item onClick={handleOpen1}>
                <Stack spacing={80}>
                  <Stack direction="column" alignItems="flex-start">
                    <b>Create Catalogue</b>
                    <p>Create catalogue for a buyer</p>
                  </Stack>
                  <Stack>
                    <Icon as={ProjectIcon} />
                  </Stack>
                </Stack>
              </Dropdown.Item>
              <Dropdown.Item onClick={handleOpen2}>
                <Stack spacing={90}>
                  <Stack direction="column" alignItems="flex-start">
                    <b>Create Quotation</b>
                    <p>Quotation for a verification</p>
                  </Stack>
                  <Stack>
                    <Icon as={TreemapIcon} />
                  </Stack>
                </Stack>
              </Dropdown.Item>
            </Dropdown>
          </Stack>
        </Stack>
        <Divider style={{ marginTop: '-14px', marginBottom: '1px' }} />
        <div className="row">
          <Panel>
            <Table
              rowHeight={60}
              data={noData ? [] : paginatedData}
              height={tableHeight}
              rowClassName={() => "fixed-row"}
              rowKey="id"
              loading={loading}
              bordered
              cellBordered
              wordWrap="break-word"
            >
              {defaultColumns.map(column => {
                if (columnKeys.includes(column.key)) {
                  const { key, label, headerCell, cell, ...rest } = column;
                  return (
                    <Table.Column {...rest} key={key}>
                      {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                      {cell || <CustomCell dataKey={key} />}
                    </Table.Column>
                  );
                }
                return null;
              })}
            </Table>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={['total', '-', '|', 'pager', 'skip']}
              total={dataWithSerialNumbers.length}
              limit={10}
              activePage={currentPage}
              onChangePage={setCurrentPage}
              style={{ marginTop: '5px' }}
            />
          </Panel>
        </div>
        <Modal size="lg" open={showModal} onClose={() => setShowModal(false)} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <Stack style={{ marginRight: '10px' }} justifyContent="space-between">
                <b>Select Products to Add/Remove</b>{' '}
                <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </Stack>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table
              data={data123}
              autoHeight
              rowKey="id"
              cellBordered
              rowHeight={60}
            >
              <Table.Column width={80} align="center">
                <Table.HeaderCell>
                  <b>Select</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {rowData => (
                    <Checkbox
                      value={rowData.id}
                      checked={modalSelectedItems.includes(rowData.id)}
                      onChange={(value, checked) => handleModalCheckboxChange(value, checked)}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
              <Table.Column flexGrow={1} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.ProductName}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ProductName" />
              </Table.Column>
              <Table.Column flexGrow={1} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.AliasCode}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ProductId" />
              </Table.Column>
              <Table.Column flexGrow={1} align="center">
                <Table.HeaderCell>
                  <b>Image</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {rowData => (
                    // console.log("RowData :", rowData),
                    // console.log(`${ip}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`)
                    <img
                      src={`${ip}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                      alt="Product Image"
                      style={{ width: 50, height: 50 }}
                    />
                  )}
                </Table.Cell>
              </Table.Column>
            </Table>
            <div style={{ padding: 20 }}>
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={5}
                size="xs"
                layout={['total', '-', 'pager', 'skip']}
                total={meta123?.pagination?.total || 1}
                activePage={page}
                onChangePage={setPage}
                onChangeLimit={handleChangeLimit}
              />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              style={{ marginTop: '20px' }}
              onClick={handleConfirmModal}
              appearance="primary"
              color="cyan"
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        <TableCustomizeDetails
          {...{ open, handleClose, defaultColumns, columnKeys, setColumnKeys }}
        />
        <Modal open={open1} onClose={handleClose1} backdrop={'static'} size="lg">
          <Modal.Header>
            <b>1.Please fill the catalogue details.</b>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Catalogue Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="catalogueName"
                      name="catalogueName"
                      value={cata && cata.catalogueName ? cata.catalogueName : ''}
                      onChange={value => handleInputChange('catalogueName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerCompany"
                      name="BuyerCompany"
                      value={cata && cata.BuyerCompany ? cata.BuyerCompany : ''}
                      onChange={value => handleInputChange('BuyerCompany', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerName"
                      name="BuyerName"
                      value={cata && cata.BuyerName ? cata.BuyerName : ''}
                      onChange={value => handleInputChange('BuyerName', value, 0)}
                      block
                      onOpen={fetchData3}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="BuyerEmail"
                      name="BuyerEmail"
                      value={cata && cata.BuyerEmail ? cata.BuyerEmail : ''}
                      onChange={value => handleInputChange('BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>

            {/* <Form.Group controlId="radioList">
              <RadioGroup name="radioList" value={selectedFormat} onChange={handleFormatChange}>
                <b>2. Catalogue Format</b>
                <Stack>
                  <Radio value="A">PPT</Radio>
                  <Radio value="B">Excel</Radio>
                  <Radio value="C">PDF</Radio>
                  <Radio value="D">Generate Link</Radio>
                </Stack>
              </RadioGroup>
            </Form.Group> */}

            {/* yehi h  Catalogue save ka */}

            {selectedFormat === 'D' && (
              <Stack>
                <Form>
                  <FlexboxGrid justify="start">
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>Link</Form.ControlLabel>
                        <Input name="name" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>UserName</Form.ControlLabel>
                        <Input name="name" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>Password</Form.ControlLabel>
                        <Input name="name" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>Time Frame</Form.ControlLabel>
                        <Input type="date" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>Remark</Form.ControlLabel>
                        <Input name="name" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </Form>
              </Stack>
            )}

            {/* <Form.Group controlId="radioList" style={{ marginTop: '15px' }}>
              <RadioGroup name="radioList" value={selectedShare} onChange={handleFormatChangeShare}>
                <b>3. Share by</b>
                <Stack>
                  <Radio value="A">Direct Download</Radio>
                  <Radio value="B">Email</Radio>
                  <Radio value="C" >Whatsapp</Radio>
                </Stack>
              </RadioGroup>
            </Form.Group> */}
            {selectedShare === 'B' && (
              <Stack>
                <Form>
                  <FlexboxGrid justify="space-around">
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>To</Form.ControlLabel>
                        <Input name="name" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>From</Form.ControlLabel>
                        <Input name="name" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>Subject</Form.ControlLabel>
                        <Input name="name" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Form.Group controlId="name">
                        <Form.ControlLabel>Body</Form.ControlLabel>
                        <Input name="name" />
                      </Form.Group>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </Form>
              </Stack>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              {/* <Button onClick={handleClose1} appearance="ghost" color='cyan'>
                Preview
              </Button> */}

              <Button onClick={datattt} appearance="primary" color="cyan">
                Finish
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>

        <Modal open={open2} onClose={handleClose2} backdrop={'static'} size="lg">
          <Modal.Header>
            <b>Please fill the Quotation details.</b>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Quotation Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="QuotationName"
                      name="QuotationName"
                      value={qut && qut.QuotationName ? qut.QuotationName : ''}
                      onChange={value => handleInputChangeQ('QuotationName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="Q_BuyerCompany"
                      name="Q_BuyerCompany"
                      value={qut && qut.Q_BuyerCompany ? qut.Q_BuyerCompany : ''}
                      onChange={value => handleInputChangeQ('Q_BuyerCompany', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="Q_BuyerName"
                      name="Q_BuyerName"
                      value={qut && qut.Q_BuyerName ? qut.Q_BuyerName : ''}
                      onChange={value => handleInputChangeQ('Q_BuyerName', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="Q_BuyerEmail"
                      name="Q_BuyerEmail"
                      value={qut && qut.Q_BuyerEmail ? qut.Q_BuyerEmail : ''}
                      onChange={value => handleInputChangeQ('Q_BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              <Button onClick={datattt2} appearance="primary" color="cyan">
                Finish
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>

        <Modal open={open4} onClose={handleClose4} backdrop="static">
          <Modal.Header>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>Saved Successfully</b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Stack spacing={15} alignItems="flex-end" justifyContent="flex-end">
              <Link to={`/${ugr}/manageOrdQ`}>
                <Button appearance="subtle" active>
                  Manage Quotation
                </Button>
              </Link>
              <Link to={`/${ugr}/selection`}>
                <Button appearance="primary" color="cyan">
                  Ok
                </Button>
              </Link>
            </Stack>
          </Modal.Footer>
        </Modal>

        <Footer />
      </Container>
    </>
  );
};

export default EditDetailsC;